import styles from './Layout.module.css';
import React, { useEffect, useState } from 'react';
import { useLocation, useOutlet } from 'react-router-dom';
import {
    setLocalStorageItem,
    getLocalStorageItem,
    removeLocalStorageItem,
} from '@maxis/client-logic/utils/localStorageUtil';
import { LOCAL_STORAGE_KEYS, PAGE_RENDER_TYPE } from '@maxis/client-logic/constants/enumerates';
import TopMenu from './TopMenu';
import SideMenu from './SideMenu';
import { useBoundStore } from '@maxis/client-logic/store/useBoundStore';
import { useNavigate } from 'react-router-dom';
import HelpAI from '@maxis/components/components/HelpAIChat/HelpAI';
import NoticeContainer from './NoticeContainer';

const Layout = () => {
    const outlet = useOutlet();
    const { pageRenderType } = useBoundStore((state) => state.menu);
    const accessToken = getLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    const { userId, pwChangeDt } = useBoundStore((state) => state.user);

    const location = useLocation();
    const navigate = useNavigate();

    const [aiOpen, setAiOpen] = useState(false);


    useEffect(() => {
        // 비밀번호 변경 한 적 업으면 비밀번호 변경 페이지로
        if (pwChangeDt === null) {
            navigate(import.meta.env.VITE_PUBLIC_URL + '/password-change');
            return;
        }

        if (location) {
            // 도메인입력 + 라우터 경로를 입력했을 때
            if (location.pathname !== '/') {
                // 토큰이 있다면 입력된 라우터 경로로 이동
                if (accessToken) {
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.SEARCH, location.search);
                    navigate(location.pathname + location.search);
                }
                // 토큰이 없다면
                else {
                    // 로컬 스토리지에 입력된 경로를 저장 후 로그인 페이지로 이동
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.PATH_NAME, location.pathname);
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.SEARCH, location.search);
                    navigate(import.meta.env.VITE_PUBLIC_URL + `/login`);
                }
            }
            // 도메인만 입력했을 때
            else {
                // 토큰이 없다면 로그인 페이지로 이동
                if (!accessToken) {
                    removeLocalStorageItem(LOCAL_STORAGE_KEYS.PATH_NAME);
                    removeLocalStorageItem(LOCAL_STORAGE_KEYS.SEARCH);
                    navigate(import.meta.env.VITE_PUBLIC_URL + `/login`);
                }
            }
        }
    }, []);

    return (
        <div className={styles.wrap}>
            {!accessToken ? <></> : <TopMenu setAiOpen={setAiOpen} />}
            {!accessToken ? <></> : <SideMenu />}
            <div
                className={styles.contents}
                style={{
                    marginLeft: '0px',
                    ...(pageRenderType === PAGE_RENDER_TYPE.PAGE ? { padding: '10px 30px 30px 5px' } : null),
                }}
            >
                {outlet}
            </div>
            {/* 로그인 되어 있을때만 공지사항 보이게 */}
            {userId !== '' && <NoticeContainer />}

            {accessToken && aiOpen && <HelpAI openState={setAiOpen} />}
        </div>

        // <div>
        // <TopMenu />
        // <div className={styles.container}>
        //   <div className={styles.wrap}>
        //     <div className={styles.layout}>
        //       <SideMenu />
        //       <div className={styles.contents} style={{marginLeft:'-35px'}}>{outlet}</div>
        //     </div>
        //   </div>
        // </div>
        // <Footer />
        // </div>
    );
};

Layout.displayName = 'Layout';
export default Layout;
